export class ReferredUserAddress {
    public city: string = '';
    public state: string = '';
    public country: string = '';
}